<template>
  <div>
    <div class="navbar">
      <div class="container">
        <div class="row justify-content-between" style="width:100%">
          <img src="../assets/Image/pic_logo_live720.png" alt="LiveVR 720">
          <ul class="nav-body">
              <!-- <li>我的平台</li>
              <li>關於live720</li>
              <li>產品實例</li>
              <li>產品支援</li>
              <li>方案價格</li> -->
            <li class="m-auto">
              <router-link v-if="!islogin" class="loginBtn" :to ="{ name: 'login' }">
                會員登入
              </router-link>
              <router-link v-else :to ="{ name: 'exam.editor' }" class="loginBtn" >
                {{$t('enter_editing')}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="banner">
      <div class="banner-content">
        <h2>增加視覺體驗</h2>
        <h4>串聯人物、物及時空，讓體驗更加真實</h4>
        <button type="button" class="btn btn-purple">如何做到</button>
        <button class="btn btn-outline-purple">立刻體驗</button>
      </div>
    </div>

    <main v-if="list" class="main-bg">
      <div class="container py-2">
        <h4 class="py-4 ">Live720 Gallery</h4>
        <div class="row mx-auto" style="width: 90%">
          <div v-for=" item in list" :key="item.id" class="col-md-3 col-sm-6 p-2">
            <a class="card-img" @click="$router.push({ name: 'viewer', params: { 'id': item.buildingId }})">
              <switchImg class="custom-thumbnail" :inputName="item.name" :imageOn="item.thumbnail" :imageOff="item.thumbnail" v-if="item.thumbnail" />
              <switchImg :inputName="item.name" v-else />
            </a>
          </div>
        </div>
      </div>
    </main>

    <footer v-if="isliveAbc" class="footer-bg">
      <div class="footer-content">
        <span class="footer-line"></span>
          <span class="footer-title">
          客戶服務
          </span>
        <span class="footer-line"></span>
        </div>
        <div>
          <ul>
            <li>服務電話:(02)2578-2626</li>
            <li class="none">|</li>
            <li>客服時間:週一至週五 09:00 ~ 18:00</li>
            <li class="none">|</li>
            <li>客服信箱:service@liveabc.com</li>
          </ul>
        </div>
        <p>Copyright@Heborn Soft Limited. All Rights Reserved</p>
    </footer>
    <footer v-else class="footer-bg">
      <div class="footer-content">
        <span class="footer-line"></span>
          <span class="footer-title">
            Service
          </span>
        <span class="footer-line"></span>
        </div>
        <div>
          <ul>
            <li>Phone:(+886)225782626</li>
            <li class="none">|</li>
            <li>Office Hours:Mon ~ Fri 09:00 ~ 18:00</li>
            <li class="none">|</li>
            <li>email:service@liveabc.com</li>
          </ul>
        </div>
        <p>Copyright@Heborn Soft Limited. All Rights Reserved</p>
    </footer>
  </div>
</template>

<script>

// @ is an alias to /src
import axios from 'axios'
import switchImg from '@/components/SwitchImg.vue'

export default {
  name: 'index',

  components: {
    switchImg
  },

  data () {
    return {
      list: null,
      islogin: false,
      isliveAbc: false
    }
  },

  async mounted () {
    if (window.localStorage.getItem('login')) {
      this.islogin = true
      let self = this
      const user = JSON.parse(window.localStorage.getItem('login'))
      this.isliveAbc = user.username
      // this.login(user.username, user.password).then(() => {
      axios.get(`https://api.liveabc.com/v1/720vr/${user.username}`).then((data) => {
        self.list = data.data || []
        console.log(self.list)
      })
      // })
    }
  },
  methods: {
    async login (username, password) {
      const { data } = await axios.post('https://vrcam-prod-api.istaging.com/api/v1/users/login', {
        'username': username,
        'password': password
      })
      axios.defaults.headers.common['tenantId'] = data.id
      axios.defaults.headers.common['tenant-token'] = data.tenantToken
    }
  }
}
</script>

<style lang="scss" scoped>
img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.navbar{
  position: absolute;
  width: 100%;
  color: #ffffff;
}
.nav-body {
  margin: 5px;
  display: flex;
  list-style: none;
  justify-content: flex-end;
  padding: 0;
  li {
    margin: 0 20px;
  }
}

.banner {
  height: 80vh;
  color: #ffffff;
  background-color: #000000;
  background-image: url('../assets/Image/pic_main_bg.jpg');
  background-position: center;
  background-size: cover;
  display:flex;
  align-items:center;
  justify-content:center;
  .banner-content {
    h2 {
      font-size: 3rem;
    }
    button{
      margin: 1rem .5rem;
    }
  }
}
.thumbnail{
  border-radius: 10px;
}
.footer-bg {
  background-color: #aeb2fa;
  color: #ffffff;
  padding-top: 1rem;
  width: 100%;
  .footer-content,p,ul {
    text-align: center;
    padding-bottom: 1rem;
    margin: 0;
  }
  .footer-line {
    display: inline-block;
    width: 30vw;
    border-top: 1px solid #ffffff;
  }
  .footer-title {
    margin: 1rem;
    width: 80%;
    font-family: Microsoft JhengHei;
    font-weight:bold;
    font-size: 1rem;
    vertical-align: -4px;
  }
  @media screen and (min-width: 600px){
    ul {
      display: flex;
      justify-content:center;
    }
    .none{
      display: block !important;
    }
  }
  li {
    font-size: 1rem;
    list-style:none;
    margin: 10px 20px;
  }
  .none {
    display: none;
  }
}
a.card-img {
  cursor: pointer;
}
.custom-thumbnail {
  border: 1px solid #d4d4d4;
  overflow: hidden;
  border-radius: 10px;
  padding: 0.65em
}
.loginBtn {
  color: #ffff;
  text-decoration: none;
}
.loginBtn:hover {
  text-shadow: 0 0 0.2em rgb(182, 182, 182), 0 0 0.2em rgb(182, 182, 182),
    0 0 0.2em rgb(182, 182, 182);
}
</style>
